import { render } from "./check_box.vue?vue&type=template&id=bc11e738&lang=pug"
import script from "./check_box.vue?vue&type=script&lang=js"
export * from "./check_box.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__